import { useSearchParams } from 'react-router-dom'
import Page from '../../Components/Page'
import { HEADBOX_ROOT_SERVICE } from '../../Constants'
import SuccessMessage from './EndScreenMessage'
import './SuccessPage.less'
import '../../Styles/buttons.less'
import useBriefContext from '../../Hooks/Brief/useBriefContext'
import { useEffect } from 'react'
import getGuestEventsURL from './getGuestEventsURL'
import Spinner from '../../Components/LoadingSpinner'

const SuccessLink = ({ secret }: { secret: string | null }): JSX.Element =>
  secret ? (
    <a
      className='hb-button primary-button'
      href={getGuestEventsURL({ lfAccessSecret: secret, showSuccess: false }).toString()}>
      View your enquiry
    </a>
  ) : (
    <a href={HEADBOX_ROOT_SERVICE}>Back to HeadBox</a>
  )

const SuccessPage = (): JSX.Element => {
  const { setShowBizLayout } = useBriefContext()
  const [searchParams] = useSearchParams()
  const lfAccessSecret = searchParams.get('secret')
  const briefType = searchParams.get('type')
  const country = searchParams.get('country')
  const messageKey = briefType === 'business' && country === 'AU' ? 'au-biz' : briefType
  const redirectToGexp = !!lfAccessSecret && briefType !== 'business'

  useEffect(() => {
    setShowBizLayout(true) // hide LF messaging
  }, [])

  useEffect(() => {
    if (redirectToGexp) {
      const timeout = setTimeout(() => {
        const gexpURL = getGuestEventsURL({ lfAccessSecret, showSuccess: true })

        return window.location.replace(gexpURL) // redirection to Guest Experience
      }, 700)

      return () => clearTimeout(timeout)
    }
  }, [redirectToGexp])

  return redirectToGexp ? (
    <Spinner fullPage={true} fadeIn={true} />
  ) : (
    <Page
      metaTitle='All done! - HeadBox'
      heading='Brilliant! Enquiry submitted.'
      className='success-page fade-in'
      hidden={redirectToGexp}>
      <SuccessMessage messageKey={messageKey} />
      {lfAccessSecret && <SuccessLink secret={lfAccessSecret} />}
    </Page>
  )
}

export default SuccessPage
